<template>
  <div>
    <img id="preview" :src="photo" alt="Captured Photo" />
    <button @click="sendPhoto">Send Photo</button>
  </div>
</template>

<script>
import EventBus from '../../event-bus';
export default {
//   props: ['photo'],
 data() {
    return {
        photo: null,
    };
 },
  mounted() {
    EventBus.$on('picture-taken', (data) => {
            console.log("picture-taken invoked");
            // this.modalReset();
            this.photo = data.image;
            this.width = data.width;
            this.height = data.height;
            const imgEl = document.getElementById('preview');
            imgEl.width = this.width;
            imgEl.height = this.height;
        });
},
  methods: {
    sendPhoto() {
      // Code to send the photo to the backend using Axios
      // You can use the "photo" prop to access the image data
    },
  },
};
</script>

<style>
/* Style the photo preview image */
img {
  max-width: 100%;
}
</style>
